/**
 * The two brand colours that `_variables.scss` exposes through its `:export`
 * block, read in a way that survives the css-loader upgrade.
 *
 * css-loader 6 (which came with vue-cli 5) changed how an ICSS `:export` block
 * reaches JavaScript: `import variables from '...scss'` used to hand back the
 * locals directly, and now hands back a module namespace whose locals sit on
 * `default`. Components were reading `variables.primary` and getting
 * `undefined`, which threw "Cannot read properties of undefined (reading
 * 'primary')" on every page with a search box.
 *
 * Both shapes are handled here so there is one place to fix if it changes
 * again.
 */

import * as scssModule from '@/assets/scss/generic/_variables.scss';

const resolved = scssModule && scssModule.default ? scssModule.default : scssModule;

export default {
	base: resolved.base,
	primary: resolved.primary
};
